module.exports = __webpack_public_path__ + "static/media/downloadIcon.7a4590e2.svg";